import Vue from 'vue';
import Router from 'vue-router';
import { constantRouterMap } from './router.config.js';
// hack router push callback
var originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
// 路由动画，返回向左滑动
Router.prototype.back = function () {
  this.isBack = true;
  window.history.go(-1);
};
Vue.use(Router);
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // 如果你是 history模式 需要配置vue.config.js publicPath
    // base: process.env.BASE_URL,
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRouterMap
  });
};
var router = createRouter();

// router.beforeEach((to, from, next) => {
// console.log(to, from, 'to.name, from.name')
// localStorage.setItem('fromPage', from.name)
// if (to.name === 'error' && from.name === 'location') {
//   return
// } else {
//   (
//     next()
//   )
// }
// })

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;